import { ContactSlugEnum as c } from "@systemeio/ui";
const r = (s, o) => Object.keys(s).includes(o), d = (s, o) => {
  const e = [];
  return Object.values(c).forEach((t) => {
    const i = r(o, t), n = r(s, t);
    !i && n && e.push(...s[t]);
  }), e;
};
export {
  d as getMissingFieldsErrors
};
